import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export const Layout = ({ children }) => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const el = document.getElementById(hash.replace("#", ""));
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return (
        <div className="min-h-screen flex flex-col bg-ink text-neutral-800">
            <Navbar />
            <main className="flex-1 relative">{children}</main>
            <Footer />
        </div>
    );
};

export default Layout;
